import log from '@/utils/consolelog'
import generateBase64Picture from '@/utils/generateBase64Picture'
import watches from '@/api/modules/watches'
import profile from '@/api/modules/profile'
import files from '@/api/modules/files'
import * as mutations from './mutations'

const watchesInitialState = {
	data: [],
	loading: false,
	error: null
}

const watchInitialState = {
	data: null,
	loading: false,
	error: null,
	timestamp: null
}

const profileInitialState = {
	data: null,
	loading: false,
	error: null
}

const pictureInitialState = {
	data: null,
	loading: false,
	error: null
}

const adminInitialState = {
	watches: Object.assign({}, watchesInitialState),
}

export default {
	state: Object.assign({}, adminInitialState),
	getters: {
		getAdminWatch: state => id => state.watches.data.find(watch => watch.data.id == id ),
	},
	mutations: {
		[mutations.ADMIN_ALLOC_WATCH] (state, watch_id) {
			const watch = Object.assign({}, watchInitialState)
			watch.data = {}
			watch.data.id = watch_id
			watch.data.profile = Object.assign({}, profileInitialState)
			state.watches.data.push(watch)
		},
		[mutations.ADMIN_ADD_WATCH] ( state , data) {
			let watch = state.watches.data.find(ele => ele.data.id == data.id)
			if (!watch) {
				watch = Object.assign({}, watchInitialState)
			}
			watch.data = data
			watch.timestamp = Date.now()
			
			const watches = state.watches.data.filter(ele => ele.data.id != data.id)
			watches.push(watch)
			state.watches.data = watches
		},
		[mutations.ADMIN_WATCH_LOADING] (state, { watch_id, value }) {
			let watch = state.watches.data.find(ele => ele.data.id == watch_id)
			if (watch) {
				watch.loading = value
				watch.data.profile.loading = value
			}
		},
		[mutations.ADMIN_WATCH_ERROR] (state, { watch_id, error }) {
			let watch = state.watches.data.find(ele => ele.data.id == watch_id)
			if (watch)
				watch.error = error
		},
	},
	actions: {
		getAdminWatch({ commit }, { context, user_uid, watch_id }) {

			const getWatch = function (context, user_uid, watch_id) {
				return watches.get(context, user_uid, watch_id)
				.then(response => {
					log.log('store', 'watches.get OK', response)()
					const watch = response.body
					watch.profile = Object.assign({}, profileInitialState)
					watch.picture_uid = watch.picture
					watch.picture = Object.assign({}, pictureInitialState)
					return watch
				}).catch(error => {
					log.error('store', 'watches.get ERROR', error)()
				})
			}

			const getProfile = function (context, user_uid, watch_id) {
				return profile.get(context, user_uid, watch_id)
					.then(response => {
						log.log('store', 'profile.get OK', response)()
						return response.body
					}).catch(error => {
						log.error('store', 'profile.get ERROR', error)()
					})
			}

			commit(mutations.ADMIN_ALLOC_WATCH, watch_id)
			commit(mutations.ADMIN_WATCH_LOADING, { watch_id , value: true })
			Promise.all([ getWatch(context, user_uid, watch_id), getProfile(context, user_uid, watch_id) ])
				.then(([ watch, profile ]) => {
					log.info('store', 'getAdminWatch() OK', [ watch, profile ])()
					watch.profile.data = profile
					commit(mutations.ADMIN_ADD_WATCH, watch)
				}).catch(error => {
					log.error('store', 'getAdminWatch() ERROR', error)()
					commit(mutations.ADMIN_WATCH_ERROR, { watch_id , error })
				}).finally(() => {
					commit(mutations.ADMIN_WATCH_LOADING, { watch_id , value: false })
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/admin.js